import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_BiopsychosocialChild = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_BiopsychosocialChild' className='file-pdf-document'>
            <div className='file-template'>



                <table>
                    {/* <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Location of Service:</span>
                            <input type='text' id="txtLocationOfService" name="txtLocationOfService" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Units of Service:</span>
                            <input type='text' id="txtUnits" name="txtUnits" className='add-only' />
                        </td>
                    </tr> */}
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Person Communicated With:</span>
                            <input type='text' id="txtPersonCommunicated" name="txtPersonCommunicated" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Telephone Contact:</span>
                            <input type='text' id="txtTelephoneContact" name="txtTelephoneContact" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Presenting Problem(s) and Requested Service(s)</h3>
                <p className='w-750'>
                    <span className='eleHeader'>What is/are presenting problem(s)?</span>
                    <span className='small'>(Why are they here? In client's own words when possible.)</span>
                    <textarea id="txtPresentingProblem" name="txtPresentingProblem" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe precipitating events:</span>
                    <textarea id="txtPrecipitatingEvents" name="txtPrecipitatingEvents" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What service(s) is the client requesting?</span>
                    <textarea id="txtServiceRequested" name="txtServiceRequested" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># of People in Family:</span>
                            <input type='text' id="txtFamilyCount" name="txtFamilyCount" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Adjusted Monthly Income:</span>
                            <input type='text' id="txtAdjIncome" name="txtAdjIncome" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Spiritual Variables:</span>
                    <textarea id="txtSpiritualVariables" name="txtSpiritualVariables" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Cultural Variables:</span>
                    <textarea id="txtCulturalVariables" name="txtCulturalVariables" className='add-only' ></textarea>
                </p>
                <h3>Lifespan/Developmental History</h3>
                <p className='w-750'>
                    <span className='eleHeader'>What is the client's prenatal history?:</span>
                    <span className='small'>(Include any substance abuse, physical abuse, medications, and illnesses during
                        Mother's pregnancy, prenatal exposure to alcohol, tobacco and other drugs)
                    </span>
                    <textarea id="txtPrenatalHx" name="txtPrenatalHx" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Health at birth:</span>
                    <textarea id="txtHealthAtBirth" name="txtHealthAtBirth" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Developmental milestones:</span>
                    <input type="checkbox" id="chkWithinLimits" name="chkWithinLimits" className='add-only' value="chkWithinLimits" /> Within Normal Limits?
                    <br />
                    <textarea id="txtDevelopmentalMilestones" name="txtDevelopmentalMilestones" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Special services received during lifetime:</span>
                    <textarea id="txtSpecialServicesReceived" name="txtSpecialServicesReceived" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other lifespan/developmental issues:</span> <span className='small'>(Include mid-life, senior/elder, other issues)</span><br />
                    <textarea id="txtOtherIssues" name="txtOtherIssues" className='add-only' ></textarea>
                </p>
                <h3>Education Assessment</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>School currently attending:</span>
                            <input type='text' id="txtCurrentSchool" name="txtCurrentSchool" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Grade:</span>
                            <input type='text' id="txtCurrentGrade" name="txtCurrentGrade" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Has the client ever been suspended or expelled from school and/or bus?:</span>
                    <span className='small'>(Include both in-school suspensions and out-of-school suspensions) If so, include
                        the number of times, dates of suspension and duration of suspension.
                    </span>
                    <textarea id="txtSuspended" name="txtSuspended" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have frequent absences?:</span>
                    <span className='small'>Include the number of times consumer has been absent.</span>
                    <textarea id="txtFrequentAbsences" name="txtFrequentAbsences" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the client currently failing, and has the client ever been retained?:</span>
                    <textarea id="txtFailingRetained" name="txtFailingRetained" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the client in special education classes?:</span>
                    <textarea id="txtInSpecialEd" name="txtInSpecialEd" className='add-only' ></textarea>
                </p>
                <h3>Family of Origin History</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Family's current and past psychiatric history:</span>
                    <textarea id="txtFamilyPsychHistory" name="txtFamilyPsychHistory" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family's and client's physical/sexual/emotional abuse
                        history:
                    </span>
                    <textarea id="txtAbuseHistory" name="txtAbuseHistory" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family's substance use/abuse history:</span>
                    <textarea id="txtSubstanceAbuseHistory" name="txtSubstanceAbuseHistory" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client's Current and Significant Past Supports:</span>
                    <span className='small'>(Social supports, family supports, significant relationships, religious
                        and spiritual supports/affiliations.)
                    </span>
                    <br />
                    <textarea id="txtSupports" name="txtSupports" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other Agencies/Systems Involved With:</span> <span className='small'>(List agencies client is involved with or receiving services from.
                        For example: Dept of Rehab, CalWORKs, ASOC, etc. Include the name of the agency
                        and primary contact person.)
                    </span>
                    <br />
                    <textarea id="txtOtherAgencies" name="txtOtherAgencies" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client's Legal History:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory1" id="chkLegalHistory1" className='add-only' value="chkLegalHistory1" />
                            Informal Probation
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory2" id="chkLegalHistory2" className='add-only' value="chkLegalHistory2" />
                            Formal Probation
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory3" id="chkLegalHistory3" className='add-only' value="chkLegalHistory3" />
                            Parole
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory4" id="chkLegalHistory4" className='add-only' value="chkLegalHistory4" />
                            Child Welfare Services
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory5" id="chkLegalHistory5" className='add-only' value="chkLegalHistory5" />
                            Conservatorship
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory6" id="chkLegalHistory6" className='add-only' value="chkLegalHistory6" />
                            D. U. I.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory7" id="chkLegalHistory7" className='add-only' value="chkLegalHistory7" />
                            Restraining Order
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory8" id="chkLegalHistory8" className='add-only' value="chkLegalHistory8" />
                            None reported
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='small'>(Describe and, if currently involved, give name of probation officer,
                        parole office, or case manager and estimated start and end dates.)
                    </span>
                    <br />
                    <textarea id="txtLegalHistory" name="txtLegalHistory" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Client's Substance Use:</span>
                    <span className='small'>(Alcohol and other drugs, check all that apply.)</span>

                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse1" id="chkSubstanceUse1" value="chkSubstanceUse1" className='add-only' />
                            Caffeine
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse2" id="chkSubstanceUse2" value="chkSubstanceUse2" className='add-only' />
                            Tobacco
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse3" id="chkSubstanceUse3" value="chkSubstanceUse3" className='add-only' />
                            Over-the-counter Medication
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse4" id="chkSubstanceUse4" value="chkSubstanceUse4" className='add-only' />
                            Prescription Medication
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse5" id="chkSubstanceUse5" value="chkSubstanceUse5" className='add-only' />
                            Alcohol
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse6" id="chkSubstanceUse6" value="chkSubstanceUse6" className='add-only' />
                            Inhalants
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse7" id="chkSubstanceUse7" value="chkSubstanceUse7" className='add-only' />
                            Hallucinogens
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse8" id="chkSubstanceUse8" value="chkSubstanceUse8" className='add-only' />
                            Marijuana
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse9" id="chkSubstanceUse9" value="chkSubstanceUse9" className='add-only' />
                            Stimulants
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse10" id="chkSubstanceUse10" value="chkSubstanceUse10" className='add-only' />
                            Sedatives
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse11" id="chkSubstanceUse11" value="chkSubstanceUse11" className='add-only' />
                            Tranqulizers
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse12" id="chkSubstanceUse12" value="chkSubstanceUse12" className='add-only' />
                            Cocaine
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse13" id="chkSubstanceUse13" value="chkSubstanceUse13" className='add-only' />
                            Barbituates
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse14" id="chkSubstanceUse14" value="chkSubstanceUse14" className='add-only' />
                            Methamphetamines
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse15" id="chkSubstanceUse15" value="chkSubstanceUse15" className='add-only' />
                            Opiates
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse16" id="chkSubstanceUse16" value="chkSubstanceUse16" className='add-only' />
                            Methadone
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" name="chkSubstanceUse17" id="chkSubstanceUse17" value="chkSubstanceUse17" className='add-only' /> Other
                            &nbsp;
                            <input type='text' id="txtMethadoneOther" name="txtMethadoneOther" className='add-only custom-add-only w-250' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Other Substance(s):</span>
                    <input type='text' id="txtOtherSubstance" name="txtOtherSubstance" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client's history of withdrawal, DTs, blackouts (loss
                        of time), seizures, etc. If applicable.
                    </span>
                    <textarea id="txtHistoryOfWithdrawal" name="txtHistoryOfWithdrawal" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ask and record the response to, "What happens when you
                        stop using?":
                    </span>
                    <textarea id="txtWhatHappens" name="txtWhatHappens" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>What is the longest period of sobriety?:</span>
                            <input type='text' id="txtLongestPeriodOfSobriety" name="txtLongestPeriodOfSobriety" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>When?:</span>
                            <input type='text' id="txtWhenPeriodOfSobriety" name="txtWhenPeriodOfSobriety" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Has the client received treatment for drug and alcohol issues?</span>
                            <select id="ddlReceivedTreatment" name="ddlReceievedTreatment" className='add-only'>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, list in-patient providers, out-patient, providers, services received, dates
                        of services, and outcomes:
                    </span>
                    <textarea id="txtTreatmentOutcomes" name="txtTreatmentOutcomes" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <h3>Patient Evaluation</h3>
                    <br />
                    <h3>Mental Status Exam </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appearance:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAppearance1" id="chkAppearance1" className='add-only' value="chkAppearance1" />
                            Unremarkable
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAppearance2" id="chkAppearance2" className='add-only' value="chkAppearance2" />
                            Unkempt
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAppearance3" id="chkAppearance3" className='add-only' value="chkAppearance3" />
                            Atypical Clothing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Orientation:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkOrientation1" id="chkOrientation1" className='add-only' value="chkOrientation1" />
                            Person
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkOrientation2" id="chkOrientation2" className='add-only' value="chkOrientation2" />
                            Place
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkOrientation3" id="chkOrientation3" className='add-only' value="chkOrientation3" />
                            Date
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkOrientation4" id="chkOrientation4" className='add-only' value="chkOrientation4" />
                            Situation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insight:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkInsight1" id="chkInsight1" className='add-only' value="chkInsight1" />
                            Poor
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkInsight2" id="chkInsight2" className='add-only' value="chkInsight2" />
                            Average
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkInsight3" id="chkInsight3" className='add-only' value="chkInsight3" />
                            Good
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Judgment:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkJudgment1" id="chkJudgment1" className='add-only' value="chkJudgment1" />
                            Poor
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkJudgment2" id="chkJudgment2" className='add-only' value="chkJudgment2" />
                            Average
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkJudgment3" id="chkJudgment3" className='add-only' value="chkJudgment3" />
                            Good
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtMentalStatusComments" name="txtMentalStatusComments" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Motor Activity</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type="checkbox" name="chkMotorActivity1" id="chkMotorActivity1" className='add-only' value="chkMotorActivity1" />
                            Unremarkable
                        </td>
                        <td className='w-300'>
                            <input type="checkbox" name="chkMotorActivity2" id="chkMotorActivity2" className='add-only' value="chkMotorActivity2" />
                            Restless
                        </td>
                        <td className='w-300'>
                            <input type="checkbox" name="chkMotorActivity3" id="chkMotorActivity3" className='add-only' value="chkMotorActivity3" />
                            Withdrawn
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkMotorActivity4" id="chkMotorActivity4" className='add-only' value="chkMotorActivity4" />
                            Slurred Speech
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Biological Functions:</span>
                    <input type="checkbox" name="chkBiologicalFunctions" id="chkBiologicalFunctions" className='add-only' value="chkBiologicalFunctions" />
                    All within normal limits
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Sleep Pattern:</span>
                    <textarea id="txtSleepPattern" name="txtSleepPattern" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Appetite:</span>
                    <textarea id="txtAppetite" name="txtAppetite" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtBiologicalFunctionsComments" name="txtBiologicalFunctionsComments"
                        className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect1" id="chkAffect1" className='add-only' value="chkAffect1" />
                            Unremarkable
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect2" id="chkAffect2" className='add-only' value="chkAffect2" />
                            Angry
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect3" id="chkAffect3" className='add-only' value="chkAffect3" />
                            Irritable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect4" id="chkAffect4" className='add-only' value="chkAffect4" />
                            Self Critical
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect5" id="chkAffect5" className='add-only' value="chkAffect5" />
                            Euphoric
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect6" id="chkAffect6" className='add-only' value="chkAffect6" />
                            Depressed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect7" id="chkAffect7" className='add-only' value="chkAffect7" />
                            Flat
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect8" id="chkAffect8" className='add-only' value="chkAffect8" />
                            Silly
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect9" id="chkAffect9" className='add-only' value="chkAffect9" />
                            Hopelessness
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Depressive-Like Behavior</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior1" id="chkDepressiveLikeBehavior1" className='add-only' value="chkDepressiveLikeBehavior1" />
                            None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior2" id="chkDepressiveLikeBehavior2" className='add-only' value="chkDepressiveLikeBehavior2" />
                            Irritability
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior3" id="chkDepressiveLikeBehavior3" className='add-only' value="chkDepressiveLikeBehavior3" />
                            Withdrawn
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior4" id="chkDepressiveLikeBehavior4" className='add-only' value="chkDepressiveLikeBehavior4" />
                            Hypoactive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior5" id="chkDepressiveLikeBehavior5" className='add-only' value="chkDepressiveLikeBehavior5" />
                            Poor Concentration
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior6" id="chkDepressiveLikeBehavior6" className='add-only' value="chkDepressiveLikeBehavior6" />
                            Self-Blame/Self-Criticism
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior7" id="chkDepressiveLikeBehavior7" className='add-only' value="chkDepressiveLikeBehavior7" />
                            Fatigue
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior8" id="chkDepressiveLikeBehavior8" className='add-only' value="chkDepressiveLikeBehavior8" />
                            Sadness
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior9" id="chkDepressiveLikeBehavior9" className='add-only' value="chkDepressiveLikeBehavior9" />
                            Loss of Interest
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior10" id="chkDepressiveLikeBehavior10" className='add-only' value="chkDepressiveLikeBehavior10" />
                            Feelings of Worthlessness
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior11" id="chkDepressiveLikeBehavior11" className='add-only' value="chkDepressiveLikeBehavior11" />
                            Change in Sexaul Interest
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior12" id="chkDepressiveLikeBehavior12" className='add-only' value="chkDepressiveLikeBehavior12" />
                            Crying
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior13" id="chkDepressiveLikeBehavior13" className='add-only' value="chkDepressiveLikeBehavior13" />
                            Guilt Feelings
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior14" id="chkDepressiveLikeBehavior14" className='add-only' value="chkDepressiveLikeBehavior14" />
                            Loss of Ability to Enjoy (Anhedonia)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior15" id="chkDepressiveLikeBehavior15" className='add-only' value="chkDepressiveLikeBehavior15" />
                            Feelings of Helpless/Hopeless
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtDepressiveLikeComments" name="txtDepressiveLikeComments" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thinking:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking1" id="chkThinking1" className='add-only' value="chkThinking1" />
                            Unremarkable
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking2" id="chkThinking2" className='add-only' value="chkThinking2" />
                            Disorganized
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking3" id="chkThinking3" className='add-only' value="chkThinking3" />
                            Flight of Ideas
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking4" id="chkThinking4" className='add-only' value="chkThinking4" />
                            Distracted
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking5" id="chkThinking5" className='add-only' value="chkThinking5" />
                            Suspicious
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking6" id="chkThinking6" className='add-only' value="chkThinking6" />
                            Confused
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking7" id="chkThinking7" className='add-only' value="chkThinking7" />
                            Delusions
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking8" id="chkThinking8" className='add-only' value="chkThinking8" />
                            Obsessions
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking9" id="chkThinking9" className='add-only' value="chkThinking9" />
                            Grandiosity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkThinking10" id="chkThinking10" className='add-only' value="chkThinking10" />
                            Hypochondriasis
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtThinkingComments" name="txtThinkingComments" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Attitude:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude1" id="chkAttitude1" className='add-only' value="chkAttitude1" />
                            Unremarkable
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude2" id="chkAttitude2" className='add-only' value="chkAttitude2" />
                            Controlling
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude3" id="chkAttitude3" className='add-only' value="chkAttitude3" />
                            Passive-Aggressive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude4" id="chkAttitude4" className='add-only' value="chkAttitude4" />
                            Egocentric
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude5" id="chkAttitude5" className='add-only' value="chkAttitude5" />
                            Hostile
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude6" id="chkAttitude6" className='add-only' value="chkAttitude6" />
                            Seductive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude7" id="chkAttitude7" className='add-only' value="chkAttitude7" />
                            Sarcastic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude8" id="chkAttitude8" className='add-only' value="chkAttitude8" />
                            Negativistic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude9" id="chkAttitude9" className='add-only' value="chkAttitude9" />
                            Manipulative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude10" id="chkAttitude10" className='add-only' value="chkAttitude10" />
                            Resistant
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" name="chkAttitude11" id="chkAttitude11" className='add-only' value="chkAttitude11" />
                            Passive
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtAttitudeComments" name="txtAttitudeComments" className='add-only'></textarea>
                </p>
                <h3>Mental Health Services History</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Current and past psychiatric history:</span>
                    <textarea id="txtPsychiatricHistory" name="txtPsychiatricHistory" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current service provider(s):</span>
                    <textarea id="txtCurrentProvider" name="txtCurrentProvider" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Past service provider(s):</span> <span className='small'>(Include in-patient, out-patient, provider names, dates, therapeutic interventions
                        and outcomes.)
                    </span>
                    <textarea id="txtPastProvider" name="txtPastProvider" className='add-only' ></textarea>
                </p>
                <h3>Medical History</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Conditions:</span> <span className='small'>(Document
                        significant past and present medical conditions, including allergies.)
                    </span>
                    <textarea id="txtMedicalConditions" name="txtMedicalConditions" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family Medical History:</span>
                    <textarea id="txtFamMedHx" name="txtFamMedHx" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Primary Care Physician's Contact Information:</span>
                    <textarea id="txtPrimaryCarePhysician" name="txtPrimaryCarePhysician" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Date of last physicial examinations:</span>
                    <input type="date" id="txtLastPhysicalExam" name="txtLastPhysicalExam" />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current with immunizations?:</span>
                    <select id="ddlCurrentImmunizations" name="ddlCurrentImmunizations" className='add-only'>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>List alternative treatments/therapies:</span>
                    <span className='small'>(IE: biofeedback, acupuncture, hypnosis, etc.)</span>
                    <textarea id="txtAlternativeTreatments" name="txtAlternativeTreatments" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If lab tests were done, list the results:</span>
                    <textarea id="txtLabResults" name="txtLabResults" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Daily Living Skills (Personal Care, Laundry, Cleaning):</span>
                    <span className='small'>(List All Tasks that consumer is able to complete/Strengths)</span><br />
                    <textarea id="txtDailyLivingSkills" name="txtDailyLivingSkills" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does client require assistive technology?:</span>
                    <span className='small'>(If yes, specify what is needed.)</span>
                    <textarea id="txtAssistiveTechRequirements" name="txtAssistiveTechRequirements" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does client display impairment in:</span>
                    <input type="checkbox" id="cbSpeechImpairment" name="cbSpeechImpairment" className='add-only' value="cbSpeechImpairment" />
                    Speech &nbsp;&nbsp;&nbsp;
                    <input type="checkbox" id="cbLangImpairment" name="cbLangImpairment" className='add-only' value="cbLangImpairment" />
                    Language &nbsp;&nbsp;&nbsp;
                    <input type="checkbox" id="cbVisionImpairment" name="cbVisionImpairment" className='add-only' value="cbVisionImpairment" />
                    Vision &nbsp;&nbsp;&nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Social/Leisure Assessment:</span> <span className='small'>(Consumer's sexual orientation, sexual behaviors, gender identity)</span><br />
                    <textarea id="txtSocialLeisure" name="txtSocialLeisure" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Consumers Height:</span>
                            <input type='text' id="txtConsumerHeight" name="txtConsumerHeight" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Consumers Weight:</span>
                            <input type='text' id="txtConsumerWeight" name="txtConsumerWeight" className='add-only w-250 custom-add-only' /> (lbs.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Consumer Satisfied with Current Weight?:</span>
                            <select id="ddlSatisfiedWithWeight" name="ddlSatisfiedWithWeight" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Eat Three Meals per Day?:</span>
                            <select id="ddlThreeMeals" name="ddlThreeMeals" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>Ever Diagnosed with an Eating Disorder?:</span>
                            <select id="ddlExerciseRegularly" name="ddlExerciseRegularly" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-400'>
                            <span className='eleHeader'>Consumer Need a Referral for a Nutritional Assessment?:</span>
                            <select id="ddlNutritionalAssessment" name="ddlNutritionalAssessment" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Medication History</span>
                    <textarea id="txtMedicationHistory" name="txtMedicationHistory" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-400'><span className='eleHeader'>Effective and compliance</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtMedication_1" name="txtMedication_1" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDosage_1" name="txtDosage_1" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtEffective_1" name="txtEffective_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtMedication_2" name="txtMedication_2" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDosage_2" name="txtDosage_2" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtEffective_2" name="txtEffective_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtMedication_3" name="txtMedication_3" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDosage_3" name="txtDosage_3" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtEffective_3" name="txtEffective_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtMedication_4" name="txtMedication_4" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDosage_4" name="txtDosage_4" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtEffective_4" name="txtEffective_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtMedication_5" name="txtMedication_5" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDosage_5" name="txtDosage_5" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtEffective_5" name="txtEffective_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtMedication_6" name="txtMedication_6" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDosage_6" name="txtDosage_6" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtEffective_6" name="txtEffective_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type="text" id="txtMedication_7" name="txtMedication_7" className='add-only' /></td>
                        <td className='w-150'> <input type="text" id="txtDosage_7" name="txtDosage_7" className='add-only' /></td>
                        <td className='w-400'> <input type="text" id="txtEffective_7" name="txtEffective_7" className='add-only' /></td>
                    </tr>
                </table>



                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>What is your preferred sexual orientation?</span>
                            <input type='text' id="txtSexOrient" name="txtSexOrient" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>How many partners have you had?</span>
                            <input type='text' id="txtSexPartners" name="txtSexPartners" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>How many partners do you currently have?</span>
                            <input type='text' id="txtSexCurrPartners" name="txtSexCurrPartners" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>What was the last STD check?</span>
                            <input type='text' id="txtSexSTDCheck" name="txtSexSTDCheck" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Did you test positive for a STD check?</span>
                            <input type='text' id="txtSexSTDPos" name="txtSexSTDPos" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Have you ever had sex against your will?</span>
                            <input type='text' id="txtSexNC" name="txtSexNC" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Have you ever traded sex for food, money, clothing, shelter, or drugs?</span>

                            <input type='text' id="txtSexTraded" name="txtSexTraded" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Current Symptoms/Problems</h3>
                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>Rate severity and duration for each:</span></td>
                        <td className='w-200'><span className='eleHeader'>Severity:</span></td>
                        <td className='w-200'><span className='eleHeader'>Duration:</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Anxiety</td>
                        <td className='w-200'>
                            <select id="ddlSeverityAnxiety" name="ddlSeverityAnxiety" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td>
                        <td className='w-200'>
                            <select id="ddlDurationAnxiety" name="ddlDurationAnxiety" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Panic Attacks</td>
                        <td className='w-200'>
                            <select id="ddlSeverityPanicAttacks" name="ddlSeverityPanicAttacks" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td>
                        <td className='w-200'>
                            <select id="ddlDurationPanicAttacks" name="ddlDurationPanicAttacks" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Phobia</td>
                        <td className='w-200'>
                            <select id="ddlSeverityPhobia" name="ddlSeverityPhobia" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td>
                        <td className='w-200'>
                            <select id="ddlDurationPhobia" name="ddlDurationPhobia" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select></td>
                    </tr>
                    <tr>
                        <td className='w-350'>Obessive Compulsive</td>
                        <td className='w-200'>
                            <select id="ddlSeverityObsessiveCompulsive" name="ddlSeverityObsessiveCompulsive"
                                className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationObsessiveCompulsive" name="ddlDurationObsessiveCompulsive"
                                className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Somatization</td>
                        <td className='w-200'>
                            <select id="ddlSeveritySomatization" name="ddlSeveritySomatization" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationSomatization" name="ddlDurationSomatization" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Depression</td>
                        <td className='w-200'>
                            <select id="ddlSeverityDepression" name="ddlSeverityDepression" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationDepression" name="ddlDurationDepression" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Impaired Memory</td>
                        <td className='w-200'>
                            <select id="ddlSeverityImpairedMemory" name="ddlSeverityImpairedMemory" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationImpairedMemory" name="ddlDurationImpairedMemory" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Poor Self Care Skills</td>
                        <td className='w-200'>
                            <select id="ddlSeveritySelfCare" name="ddlSeveritySelfCare" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationSelfCare" name="ddlDurationSelfCare" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Loss of Interest</td>
                        <td className='w-200'>
                            <select id="ddlSeverityLossOfInterest" name="ddlSeverityLossOfInterest" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationLossOfInterest" name="ddlDurationLossOfInterest" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Sexual Dysfunction</td>
                        <td className='w-200'>
                            <select id="ddlSeveritySexualDysfunction" name="ddlSeveritySexualDysfunction" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationSexualDysfunction" name="ddlDurationSexualDysfunction" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Sleep Disturbance</td>
                        <td className='w-200'>
                            <select id="ddlSeveritySleepDisturbance" name="ddlSeveritySleepDisturbance" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>

                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationSleepDisturbance" name="ddlDurationSleepDisturbance" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Appetite Disturbance</td>
                        <td className='w-200'>
                            <select id="ddlSeverityAppetiteDisturbance" name="ddlSeverityAppetiteDisturbance"
                                className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationAppetiteDisturbance" name="ddlDurationAppetiteDisturbance"
                                className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Weight Change</td>
                        <td className='w-200'>
                            <select id="ddlSeverityWeightChange" name="ddlSeverityWeightChange" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationWeightChange" name="ddlDurationWeightChange" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Bizarre Ideation</td>
                        <td className='w-200'>
                            <select id="ddlSeverityBizzareIdeation" name="ddlSeverityBizzareIdeation" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationBizarreIdeation" name="ddlDurationBizarreIdeation" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'> Bizarre Behavior</td>
                        <td className='w-200'>
                            <select id="ddlSeverityBizarreBehavior" name="ddlSeverityBizarreBehavior" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationBizarreBehavior" name="ddlDurationBizarreBehavior" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Paranoid Ideation</td>
                        <td className='w-200'>
                            <select id="ddlSeverityParanoidIdeation" name="ddlSeverityParanoidIdeation" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationParanoidIdeation" name="ddlDurationParanoidIdeation" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Gender Issues</td>
                        <td className='w-200'>
                            <select id="ddlSeverityGenderIssues" name="ddlSeverityGenderIssues" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationGenderIssues" name="ddlDurationGenderIssues" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Eating Disorders</td>
                        <td className='w-200'>
                            <select id="ddlSeverityEatingDisorders" name="ddlSeverityEatingDisorders" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationEatingDisorders" name="ddlDurationEatingDisorders" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Poor Judgment</td>
                        <td className='w-200'>
                            <select id="ddlSeverityPoorJudgment" name="ddlSeverityPoorJudgment" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationPoorJudgment" name="ddlDurationPoorJudgment" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Lack of Support System</td>
                        <td className='w-200'>
                            <select id="ddlSeveritySupportSystem" name="ddlSeveritySupportSystem" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationSupportSystem" name="ddlDurationSupportSystem" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Poor Interpersonal Skills</td>
                        <td className='w-200'>
                            <select id="ddlSeverityInterpersonal" name="ddlSeverityInterpersonal" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationInterpersonal" name="ddlDurationInterpersonal" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Conduct Problems</td>
                        <td className='w-200'>
                            <select id="ddlSeverityConductProblems" name="ddlSeverityConductProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationConductProblems" name="ddlDurationConductProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>School Problems</td>
                        <td className='w-200'>
                            <select id="ddlSeveritySchoolProblems" name="ddlSeveritySchoolProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationSchoolProblems" name="ddlDurationSchoolProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Family Problems</td>
                        <td className='w-200'>
                            <select id="ddlSeverityFamilyProblems" name="ddlSeverityFamilyProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationFamilyProblems" name="ddlDurationFamilyProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Indep. Living Problems</td>
                        <td className='w-200'>
                            <select id="ddlSeverityLivingProblems" name="ddlSeverityLivingProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationLivingProblems" name="ddlDurationLivingProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>Unusual Body Movements</td>
                        <td className='w-200'>
                            <select id="ddlSeverityBodyMovements" name="ddlSeverityBodyMovements" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationBodyMovements" name="ddlDurationBodyMovements" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'></td>
                        <td className='w-200'>
                        </td>
                        <td className='w-200'>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            Other:
                            &nbsp;
                            <input type='text' id="txtOtherSymptoms" name="txtOtherSymptoms" className='add-only w-300 custom-add-only' />

                        </td>
                        <td className='w-200'>
                            <select id="ddlSeverityOther" name="ddlSeverityOther" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-200'>
                            <select id="ddlDurationOther" name="ddlDurationOther" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60;1 Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Please describe symptoms/problems listed above in detail:</span>
                    <textarea id="txtSeveritySymptoms" name="txtSeveritySymptoms" className='add-only' ></textarea>
                </p>
                <h5>Assessment of Risk:</h5>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Suicidality:</span>
                            <select id="ddlRiskSuicidality" name="ddlRiskSuicidality" className='add-only'>
                                <option value="None">None</option>
                                <option value="Ideation">Ideation</option>
                                <option value="Plan">Plan</option>
                                <option value="Intent w/o Means">Intent w/o Means</option>
                                <option value="Intent w/ Means">Intent w/ Means</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Homicidality:</span>
                            <select id="ddlRiskHomicidality" name="ddlRiskHomicidality" className='add-only'>
                                <option value="None">None</option>
                                <option value="Ideation">Ideation</option>
                                <option value="Plan">Plan</option>
                                <option value="Intent w/o Means">Intent w/o Means</option>
                                <option value="Intent w/ Means">Intent w/ Means</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>If risk exists, client is able to contract not to harm:</span>
                            <select id="ddlRiskNoHarm" name="ddlRiskNoHarm" className='add-only'>
                                <option value="Self">Self</option>
                                <option value="Others">Others</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Impulse Control:</span>
                            <select id="ddlRiskImpulseControl" name="ddlRiskImpulseControl" className='add-only'>
                                <option value="None">None</option>
                                <option value="Ideation">Ideation</option>
                                <option value="Plan">Plan</option>
                                <option value="Intent w/o Means">Intent w/o Means</option>
                                <option value="Intent w/ Means">Intent w/ Means</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Substance Abuse:</span>
                            <select id="ddlRiskSubstanceAbuse" name="ddlRiskSubstanceAbuse" className='add-only'>
                                <option value="None">None</option>
                                <option value="Ideation">Ideation</option>
                                <option value="Plan">Plan</option>
                                <option value="Intent w/o Means">Intent w/o Means</option>
                                <option value="Intent w/ Means">Intent w/ Means</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Substance Abuse Date of Last Usage:</span>
                            <input type='date' name="txtDateOfLastUsage" id="txtDateOfLastUsage" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Substance Abuse Age of First Usage:</span>
                            <input type='text' id="txtAgeOfFirstUsage" name="txtAgeOfFirstUsage" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Sexual Abuse Victim/Perpatrator?:</span>
                            <select id="ddlSexualAbuse" name="ddlSexualAbuse" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Access to Public or Private Transporation:</span>
                            <select id="ddlAccessToPublicTransportation" name="ddlAccessToPublicTransportation" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Medical Risks:</span>
                            <select id="ddlRiskMedical" name="ddlRiskMedical" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Please explain all "Yes" answers from above:</span>
                    <textarea id="txtExplainMedicalRisks" name="txtExplainMedicalRisks" className='add-only'></textarea>
                </p>
                <h3>RISK ASSESSMENT VERSION
                </h3>
                <h3>(* elements added with permission for Lifeline centers)
                </h3>
                <p className='w-750'>
                    <strong>Instructions:</strong> Check all risk and protective factors that apply. To be completed following the patient interview, review of medical
                    record(s) and/or consultation with family members and/or other professionals.
                </p>
                <table>
                    <tr>
                        <td className='w-275'>
                            <span className='eleHeader'>Suicidal and Self-Injury Behavior</span>
                            <span className='small'>(Past Week)</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Lifetime</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Status</span> <span className='small'>(Recent) </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal1" id="chkSuicidal1" className='add-only' value="chkSuicidal1" />
                        </td>
                        <td className='w-275'>Actual suicide attempt </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkLifetime5" id="chkLifetime5" className='add-only' value="chkLifetime5" />
                        </td>
                        <td className='w-325'>Hopelessness
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical1" id="chkClinical1" className='add-only' value="chkClinical1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal2" id="chkSuicidal2" className='add-only' value="chkSuicidal2" />
                        </td>
                        <td className='w-275'>Interrupted attempt
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkLifetime4" id="chkLifetime4" className='add-only' value="chkLifetime4" />
                        </td>
                        <td className='w-325'>Helplessness*
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical2" id="chkClinical2" className='add-only' value="chkClinical2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal3" id="chkSuicidal3" className='add-only' value="chkSuicidal3" />
                        </td>
                        <td className='w-275'>Aborted attempt
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkLifetime3" id="chkLifetime3" className='add-only' value="chkLifetime3" />
                        </td>
                        <td className='w-325'>Feeling Trapped*
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical3" id="chkClinical3" className='add-only' value="chkClinical3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal4" id="chkSuicidal4" className='add-only' value="chkSuicidal4" />
                        </td>
                        <td className='w-275'>Other preparatory acts to kill self
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkLifetime2" id="chkLifetime2" className='add-only' value="chkLifetime2" />
                        </td>
                        <td className='w-325'>Major depressive episode
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical4" id="chkClinical4" className='add-only' value="chkClinical4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal5" id="chkSuicidal5" className='add-only' value="chkSuicidal5" />
                        </td>
                        <td className='w-275'>Self-injury behavior w/o suicide intent
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkLifetime1" id="chkLifetime1" className='add-only' value="chkLifetime1" />
                        </td>
                        <td className='w-325'>Mixed affective episode
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical5" id="chkClinical5" className='add-only' value="chkClinical5" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Suicide Ideation  </span>
                            <span className='small'>(Most Severe in Past Week)</span>
                        </td>
                        <td className='w-325'>Command hallucinations to hurt self
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical6" id="chkClinical6" className='add-only' value="chkClinical6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal7" id="chkSuicidal7" className='add-only' value="chkSuicidal7" />
                        </td>
                        <td className='w-325'>Wish to be dead
                        </td>
                        <td className='w-325'>Highly impulsive behavior
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical7" id="chkClinical7" className='add-only' value="chkClinical7" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal8" id="chkSuicidal8" className='add-only' value="chkSuicidal8" />
                        </td>
                        <td className='w-325'>Suicidal thoughts
                        </td>
                        <td className='w-325'>Substance abuse or dependence
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical8" id="chkClinical8" className='add-only' value="chkClinical8" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal9" id="chkSuicidal9" className='add-only' value="chkSuicidal9" />
                        </td>
                        <td className='w-325'>Suicidal thoughts with method (but without specific plan or intent to act)
                        </td>
                        <td className='w-325'>Agitation or severe anxiety
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical9" id="chkClinical9" className='add-only' value="chkClinical9" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal10" id="chkSuicidal10" className='add-only' value="chkSuicidal10" />
                        </td>
                        <td className='w-325'>Suicidal intent (without specific plan)
                        </td>
                        <td className='w-325'>Perceived burden on family or others
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical10" id="chkClinical10" className='add-only' value="chkClinical10" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal11" id="chkSuicidal11" className='add-only' value="chkSuicidal11" />
                        </td>
                        <td className='w-325'>Suicidal intent with specific plan
                        </td>
                        <td className='w-325'>Chronic physical pain or other acute medical problem (AIDS, COPD, cancer, etc.)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical12" id="chkClinical12" className='add-only' value="chkClinical12" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Activating Events </span>
                            <span className='small'>(Recent)</span>
                        </td>
                        <td className='w-325'>Homicidal ideation
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical13" id="chkClinical13" className='add-only' value="chkClinical13" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal14" id="chkSuicidal14" className='add-only' value="chkSuicidal14" />
                        </td>
                        <td className='w-325'>Recent loss or other significant negative event
                        </td>
                        <td className='w-325'>Aggressive behavior towards others
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical14" id="chkClinical14" className='add-only' value="chkClinical14" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;
                        </td>
                        <td className='w-325'>Describe:<input type="text" name="txtOtherDescribe" id="txtOtherDescribe" className='add-only' />
                        </td>
                        <td className='w-325'>Method for suicide available (gun, pills, etc.)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical15" id="chkClinical15" className='add-only' value="chkClinical15" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;
                        </td>
                        <td className='w-325'>&nbsp;
                        </td>
                        <td className='w-325'>Refuses or feels unable to agree to safety plan
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical16" id="chkClinical16" className='add-only' value="chkClinical16" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal17" id="chkSuicidal17" className='add-only' value="chkSuicidal17" />
                        </td>
                        <td className='w-325'>Pending incarceration or homelessness
                        </td>
                        <td className='w-325'>Sexual abuse (lifetime)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical17" id="chkClinical17" className='add-only' value="chkClinical17" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal18" id="chkSuicidal18" className='add-only' value="chkSuicidal18" />
                        </td>
                        <td className='w-325'>Current or pending isolation or feeling alone
                        </td>
                        <td className='w-325'>Family history of suicide (lifetime)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical18" id="chkClinical18" className='add-only' value="chkClinical18" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Treatment History</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Protective Factors</span><span className='small'>(Recent)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal19" id="chkSuicidal19" className='add-only' value="chkSuicidal19" />
                        </td>
                        <td className='w-325'>Previous psychiatric diagnoses and treatments
                        </td>
                        <td className='w-325'>Identifies reasons for living
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical19" id="chkClinical19" className='add-only' value="chkClinical19" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal20" id="chkSuicidal20" className='add-only' value="chkSuicidal20" />
                        </td>
                        <td className='w-325'>Hopeless or dissatisfied with treatment
                        </td>
                        <td className='w-325'>Responsibility to family or others; living with family
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical20" id="chkClinical20" className='add-only' value="chkClinical20" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal21" id="chkSuicidal21" className='add-only' value="chkSuicidal21" />
                        </td>
                        <td className='w-325'>Noncompliant with treatment
                        </td>
                        <td className='w-325'>Supportive social network or family
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical21" id="chkClinical21" className='add-only' value="chkClinical21" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal22" id="chkSuicidal22" className='add-only' value="chkSuicidal22" />
                        </td>
                        <td className='w-325'>Not receiving treatment
                        </td>
                        <td className='w-325'>Fear of death or dying due to pain and suffering
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical22" id="chkClinical22" className='add-only' value="chkClinical22" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Other Risk Factors</span>
                        </td>
                        <td className='w-325'>Belief that suicide is immoral, high spirituality
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical23" id="chkClinical23" className='add-only' value="chkClinical23" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal24" id="chkSuicidal24" className='add-only' value="chkSuicidal24" />
                        </td>
                        <td className='w-325'>
                            <input type="text" name="txtOtherRiskFactors1" id="txtOtherRiskFactors1" className='add-only' />
                        </td>
                        <td className='w-325'>Engaged in work or school
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical24" id="chkClinical24" className='add-only' value="chkClinical24" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal25" id="chkSuicidal25" className='add-only' value="chkSuicidal25" />
                        </td>
                        <td className='w-325'>
                            <input type="text" name="txtOtherRiskFactors25" id="txtOtherRiskFactor2" className='add-only' />
                        </td>
                        <td className='w-325'>Engaged with Phone Worker *
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical25" id="chkClinical25" className='add-only' value="chkClinical25" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal26" id="chkSuicidal26" className='add-only' value="chkSuicidal26" />
                        </td>
                        <td className='w-325'>
                            <input type="text" name="txtOtherRiskFactors3" id="txtOtherRiskFactors3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Other Protective Factors</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;
                        </td>
                        <td className='w-325'>&nbsp;
                        </td>
                        <td className='w-325'> <input type="text" name="txtOtherRiskFactors24" id="txtOtherRiskFactors24" className='add-only' /> </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal27" id="chkSuicidal27" className='add-only' value="chkSuicidal27" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any suicidal, self-injury or aggressive behavior </span><span className='small'>(include dates):</span>
                    <textarea id="txtSuicidalSelf" name="txtSuicidalSelf" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Risk History:</span> <span className='small'>(Explain any
                        significant history of suicidal, homicidal, impulse control, medical or substance
                        abuse behavior that may affect client's current level of risk or impairment to functioning.
                        Include description of plan/ideation/intent checked above.)
                    </span>
                    <br />
                    <textarea id="txtRiskHistory" name="txtRiskHistory" className='add-only'></textarea>
                </p>


                <h3> Unified Crisis/Safety Plan </h3>
                <h4>
                    Natural Supports and Agencies Involved
                </h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact Name and Title</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone number</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txtName" name="txtName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtContactName" name="txtContactName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtPhone" name="txtPhone" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txtName1" name="txtName1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtContactName1" name="txtContactName1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtPhone1" name="txtPhone1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txtName2" name="txtName2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtContactName2" name="txtContactName2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtPhone2" name="txtPhone2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>
                    Crisis/Safety Plan
                </h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Crisis Triggers</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Describe Needed Response</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Responsible Person/s </span><span className='small'>(name/phone)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Home
                        </td>
                        <td className='w-250'>
                            Client's Response
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            1.
                            <input type='text' id="txtCrisisTriggers" name="txtCrisisTriggers" className='add-only' />
                        </td>
                        <td className='w-250'>
                            1.<input type='text' id="txtDescribeNeeded" name="txtDescribeNeeded" className='add-only' />
                        </td>
                        <td className='w-250'>
                            1.<input type='text' id="txtResponsiblePerson" name="txtResponsiblePerson" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            2.
                            <input type='text' id="txtCrisisTriggers1" name="txtCrisisTriggers1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            2.<input type='text' id="txtDescribeNeeded1" name="txtDescribeNeeded1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            2.<input type='text' id="txtResponsiblePerson1" name="txtResponsiblePerson1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            3.
                            <input type='text' id="txtCrisisTriggers2" name="txtCrisisTriggers2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            3.<input type='text' id="txtDescribeNeeded2" name="txtDescribeNeeded2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            3.<input type='text' id="txtResponsiblePerson2" name="txtResponsiblePerson2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Community
                        </td>
                        <td className='w-250'>
                            Client's Response
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            1.
                            <input type='text' id="txtCrisisTriggers3" name="txtCrisisTriggers3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            1.<input type='text' id="txtDescribeNeeded3" name="txtDescribeNeeded3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            1.<input type='text' id="txtResponsiblePerson3" name="txtResponsiblePerson3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            2.
                            <input type='text' id="txtCrisisTriggers4" name="txtCrisisTriggers4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            2.<input type='text' id="txtDescribeNeeded4" name="txtDescribeNeeded4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            2.<input type='text' id="txtResponsiblePerson4" name="txtResponsiblePerson4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            3.
                            <input type='text' id="txtCrisisTriggers5" name="txtCrisisTriggers5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            3.<input type='text' id="txtDescribeNeeded5" name="txtDescribeNeeded5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            3.<input type='text' id="txtResponsiblePerson5" name="txtResponsiblePerson5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Other
                        </td>
                        <td className='w-250'>
                            Client's Response
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            1.
                            <input type='text' id="txtCrisisTriggers6" name="txtCrisisTriggers6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            1.<input type='text' id="txtDescribeNeeded6" name="txtDescribeNeeded6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            1.<input type='text' id="txtResponsiblePerson6" name="txtResponsiblePerson6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            2.
                            <input type='text' id="txtCrisisTriggers7" name="txtCrisisTriggers7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            2.<input type='text' id="txtDescribeNeeded7" name="txtDescribeNeeded7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            2.<input type='text' id="txtResponsiblePerson7" name="txtResponsiblePerson7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            3.
                            <input type='text' id="txtCrisisTriggers8" name="txtCrisisTriggers8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            3.<input type='text' id="txtDescribeNeeded8" name="txtDescribeNeeded8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            3.<input type='text' id="txtResponsiblePerson8" name="txtResponsiblePerson8" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    Crisis/Safety Plan Agreement
                </h3>
                <p className='w-750'>
                    I <input type='text' id="txtSafetyPlan" name="txtSafetyPlan" className='add-only w-250 custom-add-only' /> have participated in the development of my crisis/safety plan and I have partnered with New Beginnings Today in the development of these crisis/safety plan on my choices, preferences, and desired outcomes.
                </p>
                <table>
                    <tr>
                        <td className='w-200 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                        <td className='w-250 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-200 small">Client Signature</td>
                        <td className="w-150 small">Date</td>
                        <td className="w-250 small">NBT Staff</td>
                        <td className="w-150 small">Date</td>
                    </tr>
                </table>


                <h3>Summary of Consumer's SNAPS (Strengths, Needs, Abilities, Preferences)</h3>
                <h5>Consumer's Goals/Hopes for the Future</h5>
                <p className='w-750'>
                    <span className='eleHeader'>What things do you like about yourself?:</span>
                    <textarea id="txtLikeYourself" name="txtLikeYourself" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What things would you like to improve?:</span>
                    <textarea id="txtLikeToImprove" name="txtLikeToImprove" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are your goals for improving these behaviors?:</span>
                    <textarea id="txtImpBehGoals" name="txtImpBehGoals" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What accomplishments are you most proud of in your personal life?:</span>
                    <textarea id="txtAccomplishments" name="txtAccomplishments" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Consumer's and family's expectations from participating in this program?:</span>
                    <textarea id="txtConFamExpects" name="txtConFamExpects" className='add-only'></textarea>
                </p>
                <h5>Summary of consumer's SNAPS (Strengths, Needs, Abilities and Preferences)</h5>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths:</span>
                    <textarea id="txtSNAPStrengths" name="txtSNAPStrengths" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs:</span>
                    <textarea id="txtSNAPNeeds" name="txtSNAPNeeds" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities:</span>
                    <textarea id="txtSNAPAbilities" name="txtSNAPAbilities" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences:</span>
                    <textarea id="txtSNAPPrefs" name="txtSNAPPrefs" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Summary of Findings/Formulation:</span> <span className='small'>Identify problem areas and underlying dynamics. Include information used to make
                        differential diagnosis.)
                    </span>
                    <br />
                    <textarea id="txtSummaryOfFindings" name="txtSummaryOfFindings" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recommended Services:</span> <span className='small'>(Check all that apply.) </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" name="chkRecommendedServices1" id="chkRecommendedServices1" className='add-only' value="chkRecommendedServices1" />
                            Community referrals made, no further services needed
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices2" id="chkRecommendedServices2" className='add-only' value="chkRecommendedServices2" />
                            Medication assessment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices3" id="chkRecommendedServices3" className='add-only' value="chkRecommendedServices3" />
                            By primary care physician
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices4" id="chkRecommendedServices4" className='add-only' value="chkRecommendedServices4" />
                            By ASOC or CSOG psychiatrist
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices5" id="chkRecommendedServices5" className='add-only' value="chkRecommendedServices5" />
                            Individual therapy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices6" id="chkRecommendedServices6" className='add-only' value="chkRecommendedServices6" />
                            Brief therapy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices7" id="chkRecommendedServices7" className='add-only' value="chkRecommendedServices7" />
                            Long-term therapy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices8" id="chkRecommendedServices8" className='add-only' value="chkRecommendedServices8" />
                            Family therapy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices9" id="chkRecommendedServices9" className='add-only' value="chkRecommendedServices9" />
                            Collateral
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices10" id="chkRecommendedServices10" className='add-only' value="chkRecommendedServices10" />
                            Group
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices11" id="chkRecommendedServices11" className='add-only' value="chkRecommendedServices11" />
                            Testing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices12" id="chkRecommendedServices12" className='add-only' value="chkRecommendedServices12" />
                            Day rehab/treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" name="chkRecommendedServices13" id="chkRecommendedServices13" className='add-only' value="chkRecommendedServices13" /> Other: <input type='text' id="txtRecommendedServicesOther" name="txtRecommendedServicesOther" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If community referrals were made, please describe:</span>
                    <textarea id="txtReferralsMade" name="txtReferralsMade" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If client was placed on 1013, please give details:</span>
                    <span className='small'>(IE: Which hospital, how transported, etc.)</span><br />
                    <textarea id="txt5150Details" name="txt5150Details" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Interpretive Summary:</span>
                    <textarea id="txtInterpretiveSummary" name="txtInterpretiveSummary" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Problems List:</span>
                    <textarea id="txtProblemsList" name="txtProblemsList" className='add-only'></textarea>
                </p>
                <h3>Diagnostic Impression</h3>
                <h4>DSM-5</h4>
                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'># Diagnosis</span></td>
                        <td className='w-250'><span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            (1) <input type='text' id="txtDSM5Dx_1" name="txtDSM5Dx_1" className='add-only w-480 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input id="txtDSM5Date_1" name="txtDSM5Date_1" type='date' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            (2) <input type='text' id="txtDSM5Dx_2" name="txtDSM5Dx_2" className='add-only  w-480 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input id="txtDSM5Date_2" name="txtDSM5Date_2" type='date' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            (3) <input type='text' id="txtDSM5Dx_3" name="txtDSM5Dx_3" className='add-only w-480 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input id="txtDSM5Date_3" name="txtDSM5Date_3" type='date' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            (4) <input type='text' id="txtDSM5Dx_4" name="txtDSM5Dx_4" className='add-only w-480 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input id="txtDSM5Date_4" name="txtDSM5Date_4" type='date' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            (5) <input type='text' id="txtDSM5Dx_5" name="txtDSM5Dx_5" className='add-only w-480 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input id="txtDSM5Date_5" name="txtDSM5Date_5" type='date' />
                        </td>
                    </tr>
                </table>

                <h4>DSM-IV</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Axis I:</span>
                            <input type='text' id="txtAxis1" name="txtAxis1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Axis II:</span>
                            <input type='text' id="txtAxis2" name="txtAxis2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Axis III:</span>
                            <input type='text' id="txtAxis3" name="txtAxis3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Axis IV:</span>
                            <input type='text' id="txtAxis4" name="txtAxis4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Axis V Current GAF Score:</span>
                            <input type='text' id="txtAxis5" name="txtAxis5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>CAFAS/PECFAS (Child):</span>
                            <input type='text' id="txtCAFASPECFAS" name="txtCAFASPECFAS" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>LOCUS (Adult):</span>
                            <input type='text' id="txtLOCUS" name="txtLOCUS" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Recommendations:</span>
                    <textarea id="txtRecommendations" name="txtRecommendations" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Projected Date of Discharge/Transition:</span>
                    <input type="date" id="txtProjectedDischargeDate" name="txtProjectedDischargeDate" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Anticipated Stepdown:</span>
                    <textarea id="txtAnticipatedStepdown" name="txtAnticipatedStepdown" className='add-only'></textarea>
                </p>

                <h3>CANS
                </h3>
                <p className='w-750'>
                    <strong>Key for Traumatic/ Adverse Childhood Experience Domain</strong><br />
                    <strong>0</strong> = No evidence of any trauma of this type.<br />
                    <strong>1</strong> = "Mild" exposure, a single incident or suspicion of this trauma or ACE.<br />
                    <strong>2</strong> = Child Experienced multiple incidents or a moderate degree of this trauma or ACE.<br />
                    <strong>3</strong> = Child Experienced repeated and severe incidents of this trauma or ACE.
                </p>
                <h4>TRAUMATIC / ADVERSE CHILDHOOD EXPERIENCES</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. Sexual Abuse</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_SexualAbuse_0" name="rbAdverseChildhoodExperienceSexualAbuse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_SexualAbuse_1" name="rbAdverseChildhoodExperienceSexualAbuse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_SexualAbuse_2" name="rbAdverseChildhoodExperienceSexualAbuse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_SexualAbuse_3" name="rbAdverseChildhoodExperienceSexualAbuse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. Physical Abuse</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_PhysicalAbuse_0" name="rbAdverseChildhoodExperiencePhysicalAbuse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_PhysicalAbuse_1" name="rbAdverseChildhoodExperiencePhysicalAbuse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_PhysicalAbuse_2" name="rbAdverseChildhoodExperiencePhysicalAbuse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_PhysicalAbuse_3" name="rbAdverseChildhoodExperiencePhysicalAbuse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>3. Emotional Abuse</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_EmotionalAbuse_0" name="rbAdverseChildhoodExperienceEmotionalAbuse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_EmotionalAbuse_1" name="rbAdverseChildhoodExperienceEmotionalAbuse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_EmotionalAbuse_2" name="rbAdverseChildhoodExperienceEmotionalAbuse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_EmotionalAbuse_3" name="rbAdverseChildhoodExperienceEmotionalAbuse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>4. Neglect</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_Neglect_0" name="rbAdverseChildhoodExperienceNeglect" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_Neglect_1" name="rbAdverseChildhoodExperienceNeglect" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_Neglect_2" name="rbAdverseChildhoodExperienceNeglect" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_Neglect_3" name="rbAdverseChildhoodExperienceNeglect" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>5. Medical Trauma</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_MedicalTrauma_0" name="rbAdverseChildhoodExperienceMedicalTrauma" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_MedicalTrauma_1" name="rbAdverseChildhoodExperienceMedicalTrauma" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_MedicalTrauma_2" name="rbAdverseChildhoodExperienceMedicalTrauma" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_MedicalTrauma_3" name="rbAdverseChildhoodExperienceMedicalTrauma" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>6. Family Violence</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_FamilyViolence_0" name="rbAdverseChildhoodExperienceFamilyViolence" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_FamilyViolence_1" name="rbAdverseChildhoodExperienceFamilyViolence" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_FamilyViolence_2" name="rbAdverseChildhoodExperienceFamilyViolence" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_FamilyViolence_3" name="rbAdverseChildhoodExperienceFamilyViolence" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>7. Community Violence</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_CommunityViolence_0" name="rbAdverseChildhoodExperienceCommunityViolence" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_CommunityViolence_1" name="rbAdverseChildhoodExperienceCommunityViolence" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_CommunityViolence_2" name="rbAdverseChildhoodExperienceCommunityViolence" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_CommunityViolence_3" name="rbAdverseChildhoodExperienceCommunityViolence" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>8. School Violence</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_SchoolViolence_0" name="rbAdverseChildhoodExperienceSchoolViolence" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_SchoolViolence_1" name="rbAdverseChildhoodExperienceSchoolViolence" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_SchoolViolence_2" name="rbAdverseChildhoodExperienceSchoolViolence" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_SchoolViolence_3" name="rbAdverseChildhoodExperienceSchoolViolence" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>9. Natural or Manmade Disasters</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_ManmadeDisasters_0" name="rbAdverseChildhoodExperienceManmadeDisasters" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_ManmadeDisasters_1" name="rbAdverseChildhoodExperienceManmadeDisasters" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_ManmadeDisasters_2" name="rbAdverseChildhoodExperienceManmadeDisasters" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_ManmadeDisasters_3" name="rbAdverseChildhoodExperienceManmadeDisasters" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>10. War Affected</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_WarAffected_0" name="rbAdverseChildhoodExperienceWarAffected" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_WarAffected_1" name="rbAdverseChildhoodExperienceWarAffected" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_WarAffected_2" name="rbAdverseChildhoodExperienceWarAffected" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_WarAffected_3" name="rbAdverseChildhoodExperienceWarAffected" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>11. Terrorism Affected</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_TerrorismAffected_0" name="rbAdverseChildhoodExperienceTerrorismAffected" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_TerrorismAffected_1" name="rbAdverseChildhoodExperienceTerrorismAffected" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_TerrorismAffected_2" name="rbAdverseChildhoodExperienceTerrorismAffected" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_TerrorismAffected_3" name="rbAdverseChildhoodExperienceTerrorismAffected" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>12. Witness or Criminal Activity</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_CriminalActivity_0" name="rbAdverseChildhoodExperienceCriminalActivity" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_CriminalActivity_1" name="rbAdverseChildhoodExperienceCriminalActivity" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_CriminalActivity_2" name="rbAdverseChildhoodExperienceCriminalActivity" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_CriminalActivity_3" name="rbAdverseChildhoodExperienceCriminalActivity" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>13. Parental Criminal Behavior</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_ParentalCriminalBehavior_0" name="rbAdverseChildhoodExperienceParentalCriminalBehavior" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_ParentalCriminalBehavior_1" name="rbAdverseChildhoodExperienceParentalCriminalBehavior" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_ParentalCriminalBehavior_2" name="rbAdverseChildhoodExperienceParentalCriminalBehavior" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_ParentalCriminalBehavior_3" name="rbAdverseChildhoodExperienceParentalCriminalBehavior" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>14. Disruption in Caregiving</span>
                            <input type="radio" id="rbAdverseChildhoodExperience_DisruptioninCaregiving_0" name="rbAdverseChildhoodExperienceDisruptioninCaregiving" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_DisruptioninCaregiving_1" name="rbAdverseChildhoodExperienceDisruptioninCaregiving" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_DisruptioninCaregiving_2" name="rbAdverseChildhoodExperienceDisruptioninCaregiving" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdverseChildhoodExperience_DisruptioninCaregiving_3" name="rbAdverseChildhoodExperienceDisruptioninCaregiving" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>KEY for Symptoms Related  to Traumatic / Adverse Childhood Experiences Domain</strong><br />
                    <strong>0</strong> = No evidence of a need. I have no reason to believe that the rated item requires  any action.<br />
                    <strong>1</strong> = A need for watchful waiting, monitoring or possibly preventive action.<br />
                    <strong>2</strong> = A need for action. Some strategy is needed to address the problem/need.<br />
                    <strong>3</strong> = A need for immediate or intensive action.  This level indicates an immediate safety concern  or a priority for intervention.
                </p>
                <h4>TRAUMATIC STRESS SYMPTOMS</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>15. Adjustment to Trauma</span>
                            <input type="radio" id="rbTraumaticStressSymptoms_AdjustmenttoTrauma_0" name="rbTraumaticStressSymptomsAdjustmenttoTrauma" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_AdjustmenttoTrauma_1" name="rbTraumaticStressSymptomsAdjustmenttoTrauma" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_AdjustmenttoTrauma_2" name="rbTraumaticStressSymptomsAdjustmenttoTrauma" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_AdjustmenttoTrauma_3" name="rbTraumaticStressSymptomsAdjustmenttoTrauma" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>16. Traumatic Grief</span>
                            <input type="radio" id="rbTraumaticStressSymptoms_TraumaticGrief_0" name="rbTraumaticStressSymptomsTraumaticGrief" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_TraumaticGrief_1" name="rbTraumaticStressSymptomsTraumaticGrief" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_TraumaticGrief_2" name="rbTraumaticStressSymptomsTraumaticGrief" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_TraumaticGrief_3" name="rbTraumaticStressSymptomsTraumaticGrief" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>17. Re-experiencing</span>
                            <input type="radio" id="rbTraumaticStressSymptoms_Reexperiencing_0" name="rbTraumaticStressSymptomsReexperiencing" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Reexperiencing_1" name="rbTraumaticStressSymptomsReexperiencing" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Reexperiencing_2" name="rbTraumaticStressSymptomsReexperiencing" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Reexperiencing_3" name="rbTraumaticStressSymptomsReexperiencing" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>18. Hyperarousal</span>
                            <input type="radio" id="rbTraumaticStressSymptoms_Hyperarousal_0" name="rbTraumaticStressSymptomsHyperarousal" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms-Hyperarousal_1" name="rbTraumaticStressSymptomsHyperarousal" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Hyperarousal_2" name="rbTraumaticStressSymptomsHyperarousal" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Hyperarousal_3" name="rbTraumaticStressSymptomsHyperarousal" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>19. Avoidance</span>
                            <input type="radio" id="rbTraumaticStressSymptoms_Avoidance_0" name="rbTraumaticStressSymptomsAvoidance" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Avoidance_1" name="rbTraumaticStressSymptomsAvoidance" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Avoidance_2" name="rbTraumaticStressSymptomsAvoidance" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Avoidance_3" name="rbTraumaticStressSymptomsAvoidance" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>20. Numbing</span>
                            <input type="radio" id="rbTraumaticStressSymptoms_Numbing_0" name="rbTraumaticStressSymptomsNumbing" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Numbing_1" name="rbTraumaticStressSymptomsNumbing" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Numbing_2" name="rbTraumaticStressSymptomsNumbing" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Numbing_3" name="rbTraumaticStressSymptomsNumbing" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>21. Dissociation</span>
                            <input type="radio" id="rbTraumaticStressSymptoms_Dissociation_0" name="rbTraumaticStressSymptomsDissociation" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Dissociation_1" name="rbTraumaticStressSymptomsDissociation" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Dissociation_2" name="rbTraumaticStressSymptomsDissociation" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_Dissociation_3" name="rbTraumaticStressSymptomsDissociation" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>22. Affective/Physiological Dys.</span>
                            <input type="radio" id="rbTraumaticStressSymptoms_PhysiologicalDys_0" name="rbTraumaticStressSymptomsPhysiologicalDys" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_PhysiologicalDys_1" name="rbTraumaticStressSymptomsPhysiologicalDys" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_PhysiologicalDys_2" name="rbTraumaticStressSymptomsPhysiologicalDys" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaticStressSymptoms_PhysiologicalDys_3" name="rbTraumaticStressSymptomsPhysiologicalDys" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>CHILD STRENGTHS
                </h4>
                <p className='w-750'>
                    <strong>KEY for Strengths Domain</strong><br />
                    <strong>0</strong> = Centerpiece strength<br />
                    <strong>1</strong> = Useful strength<br />
                    <strong>2</strong> = Identified strength<br />
                    <strong>3</strong> = Not yet identified strength / NO information about a strength in this area
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>23. Family</span>
                            <input type="radio" id="rbChildStrenghts_Family_0" name="rbChildStrenghtsFamily" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Family_1" name="rbChildStrenghtsFamily" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Family_2" name="rbChildStrenghtsFamily" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Family_3" name="rbChildStrenghtsFamily" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>24. Interpersonal</span>
                            <input type="radio" id="rbChildStrenghts_Interpersonal_0" name="rbChildStrenghtsInterpersonal" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Interpersonal_1" name="rbChildStrenghtsInterpersonal" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Interpersonal_2" name="rbChildStrenghtsInterpersonal" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Interpersonal_3" name="rbChildStrenghtsInterpersonal" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>25. Educational</span>
                            <input type="radio" id="rbChildStrenghts_Educational_0" name="rbChildStrenghtsEducational" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Educational_1" name="rbChildStrenghtsEducational" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Educational_2" name="rbChildStrenghtsEducational" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Educational_3" name="rbChildStrenghtsEducational" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Educational_NA" name="rbChildStrenghtsEducational" value="NA" className='add-only' /> NA
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>26. Vocational</span>
                            <input type="radio" id="rbChildStrenghts_Vocational_0" name="rbChildStrenghtsVocational" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Vocational_1" name="rbChildStrenghtsVocational" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Vocational_2" name="rbChildStrenghtsVocational" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Vocational_3" name="rbChildStrenghtsVocational" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Vocational_NA" name="rbChildStrenghtsVocational" value="NA" className='add-only' /> NA
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>27. Coping and Savoring Skills</span>
                            <input type="radio" id="rbChildStrenghts_SavoringSkills_0" name="rbChildStrenghtsSavoringSkills" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_SavoringSkills_1" name="rbChildStrenghtsSavoringSkills" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_SavoringSkills_2" name="rbChildStrenghtsSavoringSkills" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_SavoringSkills_3" name="rbChildStrenghtsSavoringSkills" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>28. Optimism</span>
                            <input type="radio" id="rbChildStrenghts_Optimism_0" name="rbChildStrenghtsOptimism" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Optimism_1" name="rbChildStrenghtsOptimism" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Optimism_2" name="rbChildStrenghtsOptimism" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Optimism_3" name="rbChildStrenghtsOptimism" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>29. Talents/Interests</span>
                            <input type="radio" id="rbChildStrenghts_Talents_0" name="rbChildStrenghtsTalents" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Talents_1" name="rbChildStrenghtsTalents" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Talents_2" name="rbChildStrenghtsTalents" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Talents_3" name="rbChildStrenghtsTalents" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>30. Spiritual/Religious</span>
                            <input type="radio" id="rbChildStrenghts_Spiritual_0" name="rbChildStrenghtsSpiritual" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Spiritual_1" name="rbChildStrenghtsSpiritual" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Spiritual_2" name="rbChildStrenghtsSpiritual" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Spiritual_3" name="rbChildStrenghtsSpiritual" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>31. Community Life</span>
                            <input type="radio" id="rbChildStrenghts_CommunityLife_0" name="rbChildStrenghtsCommunityLife" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_CommunityLife_1" name="rbChildStrenghtsCommunityLife" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_CommunityLife_2" name="rbChildStrenghtsCommunityLife" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_CommunityLife_3" name="rbChildStrenghtsCommunityLife" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>32. Relationship Permanence</span>
                            <input type="radio" id="rbChildStrenghts_RelationshipPermanence_0" name="rbChildStrenghtsRelationshipPermanence" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_RelationshipPermanence_1" name="rbChildStrenghtsRelationshipPermanence" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_RelationshipPermanence_2" name="rbChildStrenghtsRelationshipPermanence" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_RelationshipPermanence_3" name="rbChildStrenghtsRelationshipPermanence" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>33. Resilience</span>
                            <input type="radio" id="rbChildStrenghts_Resilience_0" name="rbChildStrenghtsResilience" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Resilience_1" name="rbChildStrenghtsResilience" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Resilience_2" name="rbChildStrenghtsResilience" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildStrenghts_Resilience_3" name="rbChildStrenghtsResilience" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>KEY for Other Need Domains</strong><br />
                    <strong>0</strong> = No evidence of a need / no reason to believe that the rated item requires any action.<br />
                    <strong>1</strong> = A need for watchful waiting, monitoring or possibly preventive action.<br />
                    <strong>2</strong> = A need for action. Some strategy is needed  to address the problem/need.<br />
                    <strong>3</strong> = A need for immediate or intensive action. This level indicates an immediate safety concem or a priority for intervention.
                </p>
                <h4>LIFE DOMAIN FUNCTIONING
                </h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>34. Family</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Family_0" name="rbLifeDomainFunctioningFamily" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Family_1" name="rbLifeDomainFunctioningFamily" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Family_2" name="rbLifeDomainFunctioningFamily" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Family_3" name="rbLifeDomainFunctioningFamily" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>35. Living Situation</span>
                            <input type="radio" id="rbLifeDomainFunctioning_LivingSituation_0" name="rbLifeDomainFunctioningLivingSituation" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_LivingSituation_1" name="rbLifeDomainFunctioningLivingSituation" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_LivingSituation_2" name="rbLifeDomainFunctioningLivingSituation" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_LivingSituation_3" name="rbLifeDomainFunctioningLivingSituation" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>36. Social  Functioning</span>
                            <input type="radio" id="rbLifeDomainFunctioning_SocialFunctioning1_0" name="rbLifeDomainFunctioningSocialFunctioning1" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SocialFunctioning1_1" name="rbLifeDomainFunctioningSocialFunctioning1" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SocialFunctioning1_2" name="rbLifeDomainFunctioningSocialFunctioning1" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SocialFunctioning1_3" name="rbLifeDomainFunctioningSocialFunctioning1" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>37. Developmental</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Developmental1_0" name="rbLifeDomainFunctioningDevelopmental1" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Developmental1_1" name="rbLifeDomainFunctioningDevelopmental1" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Developmental1_2" name="rbLifeDomainFunctioningDevelopmental1" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Developmental1_3" name="rbLifeDomainFunctioningDevelopmental1" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>38. Recreational</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Recreational1_0" name="rbLifeDomainFunctioningRecreational1" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Recreational1_1" name="rbLifeDomainFunctioningRecreational1" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Recreational1_2" name="rbLifeDomainFunctioningRecreational1" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Recreational1_3" name="rbLifeDomainFunctioningRecreational1" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>39. Legal</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Legal1_0" name="rbLifeDomainFunctioningLegal1" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Legal1_1" name="rbLifeDomainFunctioningLegal1" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Legal1_2" name="rbLifeDomainFunctioningLegal1" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Legal1_3" name="rbLifeDomainFunctioningLegal1" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>40. Medical</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Medical_0" name="rbLifeDomainFunctioningMedical" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Medical_1" name="rbLifeDomainFunctioningMedical" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Medical_2" name="rbLifeDomainFunctioningMedical" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Medical_3" name="rbLifeDomainFunctioningMedical" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>41. Physical</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Physical1_0" name="rbLifeDomainFunctioningPhysical1" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Physical1_1" name="rbLifeDomainFunctioningPhysical1" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Physical1_2" name="rbLifeDomainFunctioningPhysical1" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Physical1_3" name="rbLifeDomainFunctioningPhysical1" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>42. Sleep</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Sleep1_0" name="rbLifeDomainFunctioningSleep1" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Sleep1_1" name="rbLifeDomainFunctioningSleep1" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Sleep1_2" name="rbLifeDomainFunctioningSleep1" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Sleep1_3" name="rbLifeDomainFunctioningSleep1" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>43. Sexual Development</span>
                            <input type="radio" id="rbLifeDomainFunctioning_SexualDevelopment_0" name="rbLifeDomainFunctioningSexualDevelopment" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SexualDevelopment_1" name="rbLifeDomainFunctioningSexualDevelopment" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SexualDevelopment_2" name="rbLifeDomainFunctioningSexualDevelopment" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SexualDevelopment_3" name="rbLifeDomainFunctioningSexualDevelopment" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>44. School Behavior</span>
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolBehavior_0" name="rbLifeDomainFunctioningSchoolBehavior" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolBehavior_1" name="rbLifeDomainFunctioningSchoolBehavior" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolBehavior_2" name="rbLifeDomainFunctioningSchoolBehavior" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolBehavior_3" name="rbLifeDomainFunctioningSchoolBehavior" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>45. School Achievement</span>
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolAchievement_0" name="rbLifeDomainFunctioningSchoolAchievement" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolAchievement_1" name="rbLifeDomainFunctioningSchoolAchievement" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolAchievement_2" name="rbLifeDomainFunctioningSchoolAchievement" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolAchievement_3" name="rbLifeDomainFunctioningSchoolAchievement" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>46. School Attendance</span>
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolAttendance_0" name="rbLifeDomainFunctioningSchoolAttendance" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolAttendance_1" name="rbLifeDomainFunctioningSchoolAttendance" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolAttendance_2" name="rbLifeDomainFunctioningSchoolAttendance" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SchoolAttendance_3" name="rbLifeDomainFunctioningSchoolAttendance" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>ACCULTURATION</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>47. Language</span>
                            <input type="radio" id="rbAcculturation_Language1_0" name="rbAcculturationLanguage1" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Language1_1" name="rbAcculturationLanguage1" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Language1_2" name="rbAcculturationLanguage1" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Language1_3" name="rbAcculturationLanguage1" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>48. Identity</span>
                            <input type="radio" id="rbAcculturation_Identity1_0" name="rbAcculturationIdentity1" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Identity1_1" name="rbAcculturationIdentity1" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Identity1_2" name="rbAcculturationIdentity1" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Identity1_3" name="rbAcculturationIdentity1" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>49. Ritual</span>
                            <input type="radio" id="rbAcculturation_Ritual_0" name="rbAcculturationRitual" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Ritual_1" name="rbAcculturationRitual" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Ritual_2" name="rbAcculturationRitual" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Ritual_3" name="rbAcculturationRitual" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>50. Cultural Stress</span>
                            <input type="radio" id="rbAcculturation_CulturalStress1_0" name="rbAcculturationCulturalStress1" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_CulturalStress1_1" name="rbAcculturationCulturalStress1" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_CulturalStress1_2" name="rbAcculturationCulturalStress1" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_CulturalStress1_3" name="rbAcculturationCulturalStress1" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>CHILD BEHAVIORAL/EMOTIONAL NEEDS</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>51. Psychosis</span>
                            <input type="radio" id="rbEmotionalNeeds_Psychosis_0" name="rbEmotionalNeedsPsychosis" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Psychosis_1" name="rbEmotionalNeedsPsychosis" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Psychosis_2" name="rbEmotionalNeedsPsychosis" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Psychosis_3" name="rbEmotionalNeedsPsychosis" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>52. Attention/Concentration</span>
                            <input type="radio" id="rbEmotionalNeeds_Attention_0" name="rbEmotionalNeedsAttention" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Attention_1" name="rbEmotionalNeedsAttention" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Attention_2" name="rbEmotionalNeedsAttention" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Attention_3" name="rbEmotionalNeedsAttention" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>53. Impulsivity</span>
                            <input type="radio" id="rbEmotionalNeeds_Impulsivity_0" name="rbEmotionalNeedsImpulsivity" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Impulsivity_1" name="rbEmotionalNeedsImpulsivity" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Impulsivity_2" name="rbEmotionalNeedsImpulsivity" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Impulsivity_3" name="rbEmotionalNeedsImpulsivity" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>54. Depression</span>
                            <input type="radio" id="rbEmotionalNeeds_Depression_0" name="rbEmotionalNeedsDepression" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Depression_1" name="rbEmotionalNeedsDepression" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Depression_2" name="rbEmotionalNeedsDepression" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Depression_3" name="rbEmotionalNeedsDepression" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>55. Anxiety</span>
                            <input type="radio" id="rbEmotionalNeeds_Anxiety_0" name="rbEmotionalNeedsAnxiety" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Anxiety_1" name="rbEmotionalNeedsAnxiety" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Anxiety_2" name="rbEmotionalNeedsAnxiety" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Anxiety_3" name="rbEmotionalNeedsAnxiety" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>56. Oppositional</span>
                            <input type="radio" id="rbEmotionalNeeds_Oppositional_0" name="rbEmotionalNeedsOppositional" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Oppositional_1" name="rbEmotionalNeedsOppositional" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Oppositional_2" name="rbEmotionalNeedsOppositional" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Oppositional_3" name="rbEmotionalNeedsOppositional" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>57. Conduct</span>
                            <input type="radio" id="rbEmotionalNeeds_Conduct_0" name="rbEmotionalNeedsConduct" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Conduct_1" name="rbEmotionalNeedsConduct" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Conduct_2" name="rbEmotionalNeedsConduct" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Conduct_3" name="rbEmotionalNeedsConduct" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>58. Substance Use</span>
                            <input type="radio" id="rbEmotionalNeeds_SubstanceUse_0" name="rbEmotionalNeedsSubstanceUse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_SubstanceUse_1" name="rbEmotionalNeedsSubstanceUse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_SubstanceUse_2" name="rbEmotionalNeedsSubstanceUse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_SubstanceUse_3" name="rbEmotionalNeedsSubstanceUse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>59. Attachment</span>
                            <input type="radio" id="rbEmotionalNeeds_Attachment_0" name="rbEmotionalNeedsAttachment" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Attachment_1" name="rbEmotionalNeedsAttachment" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Attachment_2" name="rbEmotionalNeedsAttachment" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Attachment_3" name="rbEmotionalNeedsAttachment" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>60. Eating Disturbance</span>
                            <input type="radio" id="rbEmotionalNeeds_EatingDisturbance_0" name="rbEmotionalNeedsEatingDisturbance" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_EatingDisturbance_1" name="rbEmotionalNeedsEatingDisturbance" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_EatingDisturbance_2" name="rbEmotionalNeedsEatingDisturbance" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_EatingDisturbance_3" name="rbEmotionalNeedsEatingDisturbance" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>61. Behavioral Regression</span>
                            <input type="radio" id="rbEmotionalNeeds_BehavioralRegression_0" name="rbEmotionalNeedsBehavioralRegression" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_BehavioralRegression_1" name="rbEmotionalNeedsBehavioralRegression" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_BehavioralRegression_2" name="rbEmotionalNeedsBehavioralRegression" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_BehavioralRegression_3" name="rbEmotionalNeedsBehavioralRegression" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>62. Somatization</span>
                            <input type="radio" id="rbEmotionalNeeds_Somatization_0" name="rbEmotionalNeedsSomatization" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Somatization_1" name="rbEmotionalNeedsSomatization" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Somatization_2" name="rbEmotionalNeedsSomatization" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_Somatization_3" name="rbEmotionalNeedsSomatization" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>63. Anger Control</span>
                            <input type="radio" id="rbEmotionalNeeds_AngerControl_0" name="rbEmotionalNeedsAngerControl" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_AngerControl_1" name="rbEmotionalNeedsAngerControl" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_AngerControl_2" name="rbEmotionalNeedsAngerControl" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEmotionalNeeds_AngerControl_3" name="rbEmotionalNeedsAngerControl" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>CHILD RISK BEHAVIORS</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>64. Suicide Risk</span>
                            <input type="radio" id="rbChildRiskBehaviors_SuicideRisk_0" name="rbChildRiskBehaviorsSuicideRisk" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_SuicideRisk_1" name="rbChildRiskBehaviorsSuicideRisk" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_SuicideRisk_2" name="rbChildRiskBehaviorsSuicideRisk" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_SuicideRisk_3" name="rbChildRiskBehaviorsSuicideRisk" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>65. Non-Suicidal Self-Injury</span>
                            <input type="radio" id="rbChildRiskBehaviors_NonSuicidalSelfInjury_0" name="rbChildRiskBehaviorsNonSuicidalSelfInjury" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_NonSuicidalSelfInjury_1" name="rbChildRiskBehaviorsNonSuicidalSelfInjury" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_NonSuicidalSelfInjury_2" name="rbChildRiskBehaviorsNonSuicidalSelfInjury" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_NonSuicidalSelfInjury_3" name="rbChildRiskBehaviorsNonSuicidalSelfInjury" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>66. Other Self Harm</span>
                            <input type="radio" id="rbChildRiskBehaviors_OtherSelfHarm_0" name="rbChildRiskBehaviorsOtherSelfHarm" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_OtherSelfHarm_1" name="rbChildRiskBehaviorsOtherSelfHarm" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_OtherSelfHarm_2" name="rbChildRiskBehaviorsOtherSelfHarm" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_OtherSelfHarm_3" name="rbChildRiskBehaviorsOtherSelfHarm" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>67. Danger to Others</span>
                            <input type="radio" id="rbChildRiskBehaviors_DangertoOthers_0" name="rbChildRiskBehaviorsDangertoOthers" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_DangertoOthers_1" name="rbChildRiskBehaviorsDangertoOthers" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_DangertoOthers_2" name="rbChildRiskBehaviorsDangertoOthers" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_DangertoOthers_3" name="rbChildRiskBehaviorsDangertoOthers" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>68. Sexual Aggression</span>
                            <input type="radio" id="rbChildRiskBehaviors_SexualAggression_0" name="rbChildRiskBehaviorsSexualAggression" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_SexualAggression_1" name="rbChildRiskBehaviorsSexualAggression" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_SexualAggression_2" name="rbChildRiskBehaviorsSexualAggression" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_SexualAggression_3" name="rbChildRiskBehaviorsSexualAggression" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>69. Runaway</span>
                            <input type="radio" id="rbChildRiskBehaviors_Runaway_0" name="rbChildRiskBehaviorsRunaway" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_Runaway_1" name="rbChildRiskBehaviorsRunaway" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_Runaway_2" name="rbChildRiskBehaviorsRunaway" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_Runaway_3" name="rbChildRiskBehaviorsRunaway" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>70. Deliequency</span>
                            <input type="radio" id="rbChildRiskBehaviors_Deliequency_0" name="rbChildRiskBehaviorsDeliequency" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_Deliequency_1" name="rbChildRiskBehaviorsDeliequency" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_Deliequency_2" name="rbChildRiskBehaviorsDeliequency" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_Deliequency_3" name="rbChildRiskBehaviorsDeliequency" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>71. Judgment</span>
                            <input type="radio" id="rbChildRiskBehaviors_Judgment_0" name="rbChildRiskBehaviorsJudgment" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_Judgment_1" name="rbChildRiskBehaviorsJudgment" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_Judgment_2" name="rbChildRiskBehaviorsJudgment" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_Judgment_3" name="rbChildRiskBehaviorsJudgment" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>72. Fire Setting</span>
                            <input type="radio" id="rbChildRiskBehaviors_FireSetting_0" name="rbChildRiskBehaviorsFireSetting" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_FireSetting_1" name="rbChildRiskBehaviorsFireSetting" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_FireSetting_2" name="rbChildRiskBehaviorsFireSetting" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_FireSetting_3" name="rbChildRiskBehaviorsFireSetting" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>73. lntentional Misbehavior</span>
                            <input type="radio" id="rbChildRiskBehaviors_lntentionalMisbehavior_0" name="rbChildRiskBehaviorslntentionalMisbehavior" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_lntentionalMisbehavior_1" name="rbChildRiskBehaviorslntentionalMisbehavior" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_lntentionalMisbehavior_2" name="rbChildRiskBehaviorslntentionalMisbehavior" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_lntentionalMisbehavior_3" name="rbChildRiskBehaviorslntentionalMisbehavior" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>74. Sexually Reactive Behavior</span>
                            <input type="radio" id="rbChildRiskBehaviors_SexuallyReactiveBehavior_0" name="rbChildRiskBehaviorsSexuallyReactiveBehavior" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_SexuallyReactiveBehavior_1" name="rbChildRiskBehaviorsSexuallyReactiveBehavior" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_SexuallyReactiveBehavior_2" name="rbChildRiskBehaviorsSexuallyReactiveBehavior" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbChildRiskBehaviors_SexuallyReactiveBehavior_3" name="rbChildRiskBehaviorsSexuallyReactiveBehavior" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>RATINGS OF CHILDREN 5 YEARS and YOUNGER - OPTIONAL DOMAIN</h4>
                <p className='w-750'>
                    <strong>This  domain  is also meant  for  use developmentally delayed children of any age, and  can  be used with any child/youth if these are areas of relevant needs regardless of child's age.
                    </strong>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>75. Motor</span>
                            <input type="radio" id="rbMotor_0" name="rbMotor" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbMotor_1" name="rbMotor" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbMotor_2" name="rbMotor" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbMotor_3" name="rbMotor" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbMotor_Na" name="rbMotor" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>76. Sensory</span>
                            <input type="radio" id="rbSensory_0" name="rbSensory" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSensory_1" name="rbSensory" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSensory_2" name="rbSensory" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSensory_3" name="rbSensory" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbSensory_Na" name="rbSensory" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>77. Communication</span>
                            <input type="radio" id="rbCommunication_0" name="rbCommunication" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCommunication_1" name="rbCommunication" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCommunication_2" name="rbCommunication" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCommunication_3" name="rbCommunication" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCommunication_Na" name="rbCommunication" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>78. Failure to Thrive</span>
                            <input type="radio" id="rbFailuretoThrive_0" name="rbFailuretoThrive" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbFailuretoThrive_1" name="rbFailuretoThrive" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbFailuretoThrive_2" name="rbFailuretoThrive" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbFailuretoThrive_3" name="rbFailuretoThrive" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbFailuretoThrive_Na" name="rbFailuretoThrive" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>79. Feeding/Elimination</span>
                            <input type="radio" id="rbElimination_0" name="rbElimination" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbElimination_1" name="rbElimination" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbElimination_2" name="rbElimination" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbElimination_3" name="rbElimination" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbElimination_Na" name="rbElimination" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>80. Birth Weight</span>
                            <input type="radio" id="rbBirthWeight_0" name="rbBirthWeight" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbBirthWeight_1" name="rbBirthWeight" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbBirthWeight_2" name="rbBirthWeight" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbBirthWeight_3" name="rbBirthWeight" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbBirthWeight_Na" name="rbBirthWeight" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbBirthWeight_U" name="rbBirthWeight" value="u" className='add-only' /> u
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>81. Prenatal Care</span>
                            <input type="radio" id="rbPrenatalCare_0" name="rbPrenatalCare" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbPrenatalCare_1" name="rbPrenatalCare" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbPrenatalCare_2" name="rbPrenatalCare" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbPrenatalCare_3" name="rbPrenatalCare" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbPrenatalCare_Na" name="rbPrenatalCare" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbPrenatalCare_u" name="rbPrenatalCare" value="u" className='add-only' /> u
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>82. Substance Exposure</span>
                            <input type="radio" id="rbSubstanceExposure_0" name="rbSubstanceExposure" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSubstanceExposure_1" name="rbSubstanceExposure" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSubstanceExposure_2" name="rbSubstanceExposure" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSubstanceExposure_3" name="rbSubstanceExposure" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbSubstanceExposure_Na" name="rbSubstanceExposure" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbSubstanceExposure_u" name="rbSubstanceExposure" value="u" className='add-only' /> u
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>83. Labor & Delivery</span>
                            <input type="radio" id="rbLaborDelivery_0" name="rbLaborDelivery" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLaborDelivery_1" name="rbLaborDelivery" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLaborDelivery_2" name="rbLaborDelivery" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLaborDelivery_3" name="rbLaborDelivery" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbLaborDelivery_Na" name="rbLaborDelivery" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbLaborDelivery_u" name="rbLaborDelivery" value="u" className='add-only' /> u
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>84. Parent/Sibling Problems</span>
                            <input type="radio" id="rbParentSiblingProblems_0" name="rbParentSiblingProblems" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbParentSiblingProblems_1" name="rbParentSiblingProblems" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbParentSiblingProblems_2" name="rbParentSiblingProblems" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbParentSiblingProblems_3" name="rbParentSiblingProblems" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbParentSiblingProblems_Na" name="rbParentSiblingProblems" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbParentSiblingProblems_u" name="rbParentSiblingProblems" value="u" className='add-only' /> u
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>85. Availability of Caregiver</span>
                            <input type="radio" id="rbAvailabilityofCaregiver_0" name="rbAvailabilityofCaregiver" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAvailabilityofCaregiver_1" name="rbAvailabilityofCaregiver" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAvailabilityofCaregiver_2" name="rbAvailabilityofCaregiver" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAvailabilityofCaregiver_3" name="rbAvailabilityofCaregiver" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbAvailabilityofCaregiver_Na" name="rbAvailabilityofCaregiver" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbAvailabilityofCaregiver_u" name="rbAvailabilityofCaregiver" value="u" className='add-only' /> u
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>86. Curiosity</span>
                            <input type="radio" id="rbCuriosity_0" name="rbCuriosity" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCuriosity_1" name="rbCuriosity" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCuriosity_2" name="rbCuriosity" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCuriosity_3" name="rbCuriosity" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCuriosity_Na" name="rbCuriosity" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>87. Playfulness</span>
                            <input type="radio" id="rbPlayfulness_0" name="rbPlayfulness" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbPlayfulness_1" name="rbPlayfulness" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbPlayfulness_2" name="rbPlayfulness" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbPlayfulness_3" name="rbPlayfulness" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbPlayfulness_Na" name="rbPlayfulness" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>88. Temperament</span>
                            <input type="radio" id="rbTemperament_0" name="rbTemperament" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTemperament_1" name="rbTemperament" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTemperament_2" name="rbTemperament" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTemperament_3" name="rbTemperament" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbTemperament_Na" name="rbTemperament" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>89. Day Care Preschool</span>
                            <input type="radio" id="rbDayCarePreschool_0" name="rbDayCarePreschool" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDayCarePreschool_1" name="rbDayCarePreschool" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDayCarePreschool_2" name="rbDayCarePreschool" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDayCarePreschool_3" name="rbDayCarePreschool" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbDayCarePreschool_Na" name="rbDayCarePreschool" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>TRANSITION TO  ADULTHOOD - OPTIONAL DOMAIN</h4>
                <p className='w-750'>
                    <strong>This domain  is meant  primarily for youth  14 and  1/2 years  or older, but can  be used with any child/youth if these are areas of relevant needs regardless of child's age.</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>90. Independent Living Skills</span>
                            <input type="radio" id="rbIndependentLivingSkills_0" name="rbIndependentLivingSkills" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbIndependentLivingSkills_1" name="rbIndependentLivingSkills" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbIndependentLivingSkills_2" name="rbIndependentLivingSkills" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbIndependentLivingSkills_3" name="rbIndependentLivingSkills" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbIndependentLivingSkills_Na" name="rbIndependentLivingSkills" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>91. Transportation</span>
                            <input type="radio" id="rbTransportation_0" name="rbTransportation" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTransportation_1" name="rbTransportation" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTransportation_2" name="rbTransportation" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTransportation_3" name="rbTransportation" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbTransportation_Na" name="rbTransportation" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>92. Parenting Roles</span>
                            <input type="radio" id="rbParentingRoles_0" name="rbParentingRoles" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRoles_1" name="rbParentingRoles" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRoles_2" name="rbParentingRoles" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRoles_3" name="rbParentingRoles" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRoles_Na" name="rbParentingRoles" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>93. Intimate Relationships</span>
                            <input type="radio" id="rbIntimateRelationships_0" name="rbIntimateRelationships" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbIntimateRelationships_1" name="rbIntimateRelationships" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbIntimateRelationships_2" name="rbIntimateRelationships" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbIntimateRelationships_3" name="rbIntimateRelationships" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbIntimateRelationships_Na" name="rbIntimateRelationships" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>94. Medication Compliance</span>
                            <input type="radio" id="rbMedicationCompliance_0" name="rbMedicationCompliance" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbMedicationCompliance_1" name="rbMedicationCompliance" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbMedicationCompliance_2" name="rbMedicationCompliance" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbMedicationCompliance_3" name="rbMedicationCompliance" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbMedicationCompliance_Na" name="rbMedicationCompliance" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>95. Education Attainment</span>
                            <input type="radio" id="rbEducationAttainment_0" name="rbEducationAttainment" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbEducationAttainment_1" name="rbEducationAttainment" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbEducationAttainment_2" name="rbEducationAttainment" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbEducationAttainment_3" name="rbEducationAttainment" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbEducationAttainment_Na" name="rbEducationAttainment" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>96. Victimization</span>
                            <input type="radio" id="rbVictimization_0" name="rbVictimization" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbVictimization_1" name="rbVictimization" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbVictimization_2" name="rbVictimization" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbVictimization_3" name="rbVictimization" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbVictimization_Na" name="rbVictimization" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>97. Job Functioning</span>
                            <input type="radio" id="rbJobFunctioning_0" name="rbJobFunctioning" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbJobFunctioning_1" name="rbJobFunctioning" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbJobFunctioning_2" name="rbJobFunctioning" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbJobFunctioning_3" name="rbJobFunctioning" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbJobFunctioning_Na" name="rbJobFunctioning" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>CAREGIVER(S) NEEDS  AND STRENGTHS</h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Title/Role of Caregiver #1 </span><span className='small'>(relation to child)</span>
                            <input type='text' id="txtRoleofCaregiver1" name="txtRoleofCaregiver1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>98. Physical</span>
                            <input type="radio" id="rbCaregiver1_Physical_0" name="rbCaregiver1Physical" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Physical_1" name="rbCaregiver1Physical" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Physical_2" name="rbCaregiver1Physical" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Physical_3" name="rbCaregiver1Physical" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Physical_Na" name="rbCaregiver1Physical" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>99. Mental Health</span>
                            <input type="radio" id="rbCaregiver1_MentalHealth_0" name="rbCaregiver1MentalHealth" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_MentalHealth_1" name="rbCaregiver1MentalHealth" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_MentalHealth_2" name="rbCaregiver1MentalHealth" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_MentalHealth_3" name="rbCaregiver1MentalHealth" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_MentalHealth_Na" name="rbCaregiver1MentalHealth" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>100. Substance Use</span>
                            <input type="radio" id="rbCaregiver1_SubstanceUse_0" name="rbCaregiver1SubstanceUse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_SubstanceUse_1" name="rbCaregiver1SubstanceUse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_SubstanceUse_2" name="rbCaregiver1SubstanceUse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_SubstanceUse_3" name="rbCaregiver1SubstanceUse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_SubstanceUse_Na" name="rbCaregiver1SubstanceUse" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>101. Developmental</span>
                            <input type="radio" id="rbCaregiver1_Developmental_0" name="rbCaregiver1Developmental" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Developmental_1" name="rbCaregiver1Developmental" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Developmental_2" name="rbCaregiver1Developmental" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Developmental_3" name="rbCaregiver1Developmental" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Developmental_Na" name="rbCaregiver1Developmental" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>102. Supervision</span>
                            <input type="radio" id="rbCaregiver1_Supervision_0" name="rbCaregiver1Supervision" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Supervision_1" name="rbCaregiver1Supervision" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Supervision_2" name="rbCaregiver1Supervision" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Supervision_3" name="rbCaregiver1Supervision" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Supervision_Na" name="rbCaregiver1Supervision" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>103. Involvement</span>
                            <input type="radio" id="rbCaregiver1_Involvement_0" name="rbCaregiver1Involvement" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Involvement_1" name="rbCaregiver1Involvement" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Involvement_2" name="rbCaregiver1Involvement" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Involvement_3" name="rbCaregiver1Involvement" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Involvement_Na" name="rbCaregiver1Involvement" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>104. Knowledge</span>
                            <input type="radio" id="rbCaregiver1_Knowledge_0" name="rbCaregiver1Knowledge" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Knowledge_1" name="rbCaregiver1Knowledge" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Knowledge_2" name="rbCaregiver1Knowledge" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Knowledge_3" name="rbCaregiver1Knowledge" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Knowledge_Na" name="rbCaregiver1Knowledge" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>105. Organization</span>
                            <input type="radio" id="rbCaregiver1_Organization_0" name="rbCaregiver1Organization" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Organization_1" name="rbCaregiver1Organization" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Organization_2" name="rbCaregiver1Organization" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Organization_3" name="rbCaregiver1Organization" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Organization_Na" name="rbCaregiver1Organization" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>106. Resources</span>
                            <input type="radio" id="rbCaregiver1_Resources_0" name="rbCaregiver1Resources" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Resources_1" name="rbCaregiver1Resources" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Resources_2" name="rbCaregiver1Resources" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Resources_3" name="rbCaregiver1Resources" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Resources_Na" name="rbCaregiver1Resources" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>107. Residential Stability</span>
                            <input type="radio" id="rbCaregiver1_ResidentialStability_0" name="rbCaregiver1ResidentialStability" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_ResidentialStability_1" name="rbCaregiver1ResidentialStability" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_ResidentialStability_2" name="rbCaregiver1ResidentialStability" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_ResidentialStability_3" name="rbCaregiver1ResidentialStability" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_ResidentialStability_Na" name="rbCaregiver1ResidentialStability" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>108. Safety</span>
                            <input type="radio" id="rbCaregiver1_Safety_0" name="rbCaregiver1Safety" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Safety_1" name="rbCaregiver1Safety" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Safety_2" name="rbCaregiver1Safety" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Safety_3" name="rbCaregiver1Safety" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_Safety_Na" name="rbCaregiver1Safety" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>109. Marital/Partner Violence</span>
                            <input type="radio" id="rbCaregiver1_MaritalViolence_0" name="rbCaregiver1MaritalViolence" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_MaritalViolence_1" name="rbCaregiver1MaritalViolence" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_MaritalViolence_2" name="rbCaregiver1MaritalViolence" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_MaritalViolence_3" name="rbCaregiver1MaritalViolence" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_MaritalViolence_Na" name="rbCaregiver1MaritalViolence" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>110. Posttraumatic Reactions</span>
                            <input type="radio" id="rbCaregiver1_PosttraumaticReactions_0" name="rbCaregiver1PosttraumaticReactions" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_PosttraumaticReactions_1" name="rbCaregiver1PosttraumaticReactions" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_PosttraumaticReactions_2" name="rbCaregiver1PosttraumaticReactions" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_PosttraumaticReactions_3" name="rbCaregiver1PosttraumaticReactions" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver1_PosttraumaticReactions_Na" name="rbCaregiver1PosttraumaticReactions" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>CAREGIVER(S) NEEDS  AND STRENGTHS</h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Title/Role of Caregiver #2 </span><span className='small'>(relation to child)</span>
                            <input type='text' id="txtRoleofCaregiver2" name="txtRoleofCaregiver2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>98. Physical</span>
                            <input type="radio" id="rbCaregiver2_Physical_0" name="rbCaregiver2Physical" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Physical_1" name="rbCaregiver2Physical" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Physical_2" name="rbCaregiver2Physical" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Physical_3" name="rbCaregiver2Physical" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Physical_Na" name="rbCaregiver2Physical" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>99. Mental Health</span>
                            <input type="radio" id="rbCaregiver2_MentalHealth_0" name="rbCaregiver2MentalHealth" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_MentalHealth_1" name="rbCaregiver2MentalHealth" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_MentalHealth_2" name="rbCaregiver2MentalHealth" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_MentalHealth_3" name="rbCaregiver2MentalHealth" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_MentalHealth_Na" name="rbCaregiver2MentalHealth" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>100. Substance Use</span>
                            <input type="radio" id="rbCaregiver2_SubstanceUse_0" name="rbCaregiver2SubstanceUse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_SubstanceUse_1" name="rbCaregiver2SubstanceUse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_SubstanceUse_2" name="rbCaregiver2SubstanceUse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_SubstanceUse_3" name="rbCaregiver2SubstanceUse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_SubstanceUse_Na" name="rbCaregiver2SubstanceUse" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>101. Developmental</span>
                            <input type="radio" id="rbCaregiver2_Developmental_0" name="rbCaregiver2Developmental" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Developmental_1" name="rbCaregiver2Developmental" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Developmental_2" name="rbCaregiver2Developmental" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Developmental_3" name="rbCaregiver2Developmental" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Developmental_Na" name="rbCaregiver2Developmental" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>102. Supervision</span>
                            <input type="radio" id="rbCaregiver2_Supervision_0" name="rbCaregiver2Supervision" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Supervision_1" name="rbCaregiver2Supervision" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Supervision_2" name="rbCaregiver2Supervision" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Supervision_3" name="rbCaregiver2Supervision" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Supervision_Na" name="rbCaregiver2Supervision" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>103. Involvement</span>
                            <input type="radio" id="rbCaregiver2_Involvement_0" name="rbCaregiver2Involvement" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Involvement_1" name="rbCaregiver2Involvement" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Involvement_2" name="rbCaregiver2Involvement" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Involvement_3" name="rbCaregiver2Involvement" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Involvement_Na" name="rbCaregiver2Involvement" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>104. Knowledge</span>
                            <input type="radio" id="rbCaregiver2_Knowledge_0" name="rbCaregiver2Knowledge" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Knowledge_1" name="rbCaregiver2Knowledge" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Knowledge_2" name="rbCaregiver2Knowledge" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Knowledge_3" name="rbCaregiver2Knowledge" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Knowledge_Na" name="rbCaregiver2Knowledge" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>105. Organization</span>
                            <input type="radio" id="rbCaregiver2_Organization_0" name="rbCaregiver2Organization" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Organization_1" name="rbCaregiver2Organization" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Organization_2" name="rbCaregiver2Organization" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Organization_3" name="rbCaregiver2Organization" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Organization_Na" name="rbCaregiver2Organization" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>106. Resources</span>
                            <input type="radio" id="rbCaregiver2_Resources_0" name="rbCaregiver2Resources" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Resources_1" name="rbCaregiver2Resources" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Resources_2" name="rbCaregiver2Resources" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Resources_3" name="rbCaregiver2Resources" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Resources_Na" name="rbCaregiver2Resources" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>107. Residential Stability</span>
                            <input type="radio" id="rbCaregiver2_ResidentialStability_0" name="rbCaregiver2ResidentialStability" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_ResidentialStability_1" name="rbCaregiver2ResidentialStability" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_ResidentialStability_2" name="rbCaregiver2ResidentialStability" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_ResidentialStability_3" name="rbCaregiver2ResidentialStability" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_ResidentialStability_Na" name="rbCaregiver2ResidentialStability" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>108. Safety</span>
                            <input type="radio" id="rbCaregiver2_Safety_0" name="rbCaregiver2Safety" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Safety_1" name="rbCaregiver2Safety" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Safety_2" name="rbCaregiver2Safety" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Safety_3" name="rbCaregiver2Safety" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_Safety_Na" name="rbCaregiver2Safety" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>109. Marital/Partner Violence</span>
                            <input type="radio" id="rbCaregiver2_MaritalViolence_0" name="rbCaregiver2MaritalViolence" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_MaritalViolence_1" name="rbCaregiver2MaritalViolence" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_MaritalViolence_2" name="rbCaregiver2MaritalViolence" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_MaritalViolence_3" name="rbCaregiver2MaritalViolence" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_MaritalViolence_Na" name="rbCaregiver2MaritalViolence" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>110. Posttraumatic Reactions</span>
                            <input type="radio" id="rbCaregiver2_PosttraumaticReactions_0" name="rbCaregiver2PosttraumaticReactions" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_PosttraumaticReactions_1" name="rbCaregiver2PosttraumaticReactions" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_PosttraumaticReactions_2" name="rbCaregiver2PosttraumaticReactions" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_PosttraumaticReactions_3" name="rbCaregiver2PosttraumaticReactions" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                            <input type="radio" id="rbCaregiver2_PosttraumaticReactions_Na" name="rbCaregiver2PosttraumaticReactions" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                        </td>
                        <td className='w-500'>&nbsp; </td>
                    </tr>
                </table>
                <h3>The Discharge Summary</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Discharge Plan (Outcome/Discharge Criteria):</span>
                    <textarea id="txtDischargePlan" name="txtDischargePlan" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-600 signature'>&nbsp;
                        </td>
                        <td className='w-150 signature'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600 small">&nbsp;
                        </td>
                        <td className="w-150 small">Date
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600 signature">&nbsp;
                        </td>
                        <td className="w-150 signature">&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="w-600 small">&nbsp;
                        </td>
                        <td className="w-150 small">Date
                        </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}







